/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Schedule_Every_DayInputs */

const vi_irrigation_schedule_every_day = /** @type {(inputs: Irrigation_Schedule_Every_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hằng ngày`)
};

/**

* @param {Irrigation_Schedule_Every_DayInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_schedule_every_day = /** @type {((inputs?: Irrigation_Schedule_Every_DayInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Schedule_Every_DayInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_schedule_every_day(inputs)
});